import { useRegisterSW } from 'virtual:pwa-register/react';

/** Shows a banner when a new app version is available (service worker update). */
export function PwaUpdater() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (registration) setInterval(() => void registration.update(), 60 * 60 * 1000);
    },
  });
  if (!needRefresh) return null;
  return (
    <div className="snackbar snackbar--update" role="alert">
      <span>Neue Version verfügbar</span>
      <button type="button" className="snackbar__action" onClick={() => void updateServiceWorker(true)}>
        Neu laden
      </button>
      <button type="button" className="snackbar__action" onClick={() => setNeedRefresh(false)}>
        Später
      </button>
    </div>
  );
}
